import { C } from "../theme";

/**
 * One predicate for "is this signal simulated?", shared by every view so the
 * live/sim story never diverges between the Settings card and the pages.
 * A value is treated as simulated unless its provenance string says otherwise.
 */
export const isSimulated = (v?: string) => !v || /simulat|unavailable|model|demo|^off$/i.test(v);

/** Live/sim provenance dot + label (e.g. on the Pump hero, Settings rows). */
export function SourceTag({ source, fallback = "Simulated" }: { source?: string; fallback?: string }) {
  const v = source ?? fallback;
  const sim = isSimulated(v);
  const color = sim ? C.beacon : C.sageDeep;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 7, fontSize: 12, color }}>
      <span
        className={sim ? undefined : "beacon-pulse"}
        style={{ width: 7, height: 7, borderRadius: 99, background: color }}
      />
      {v}
    </span>
  );
}

/** A bare provenance dot for inline use next to a number; the source shows on hover. */
export function SourceDot({ source, fallback = "Simulated" }: { source?: string; fallback?: string }) {
  const v = source ?? fallback;
  const sim = isSimulated(v);
  const color = sim ? C.beacon : C.sageDeep;
  return (
    <span
      title={v}
      className={sim ? undefined : "beacon-pulse"}
      style={{ display: "inline-block", width: 6, height: 6, borderRadius: 99, background: color, flexShrink: 0, verticalAlign: "middle" }}
    />
  );
}
